/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createReviver } from '../../factoriesAny.js';
export var reviverDependencies = {
  createReviver: createReviver
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesReviver.generated.js
// module id = 1497
// module chunks = 0